import React from "react";
import { FormControl, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select, makeStyles } from "@material-ui/core";
import { clearIcon } from "./icons-svg";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: '12px'
  }
}));

export default function InputDropdown(props) {
  const classes = useStyles();
  return (
    <>
      {props.label && props.showOutsideLabel ? <InputLabel htmlFor={props.id} className={classes.label}>{props.label}</InputLabel> : null}
      <FormControl variant="outlined" fullWidth error={props.hasError}>
        {props.label && !props.showOutsideLabel ? <InputLabel htmlFor={props.id}>{props.label}</InputLabel> : null}
        <Select
          css={props.showClearOption ? "position: relative;" : ""}
          fullWidth
          input={props.showOutsideLabel && <OutlinedInput label={props.label && !props.showOutsideLabel} id={props.id} notched={false} />}
          label={props.label}
          id={props.id}
          value={props.value}
          onChange={(e) => { props.onChange(e.target.value) }}
          disabled={props.disabled}
          error={props.hasError}
        >
          {
            (props.list && props.list.length) ?
              props.list.map((item, index) => (<MenuItem key={index} value={item.value} disabled={item.disabled}>{item.label}</MenuItem>)) : null
          }
        </Select>
        {
          props.showClearOption &&
          <div css="
                  position: absolute;
                  right: 35px;
                  top: 10px;
                  cursor: pointer"
            onClick={(e) => { e.preventDefault(); props.onClear() }}
          >
            {clearIcon()}
          </div>
        }
        {
          props.hasError ? <FormHelperText error={true}>{props.errorText}</FormHelperText> : null
        }

      </FormControl>
    </>
  );
}